
export const templateUrlConfigSys= {
  sysuser: './sysuser-editPkg.component.html',
  syska: './syska-editPkg.component.html',
  sysse: './sysse-edit.component.html',
  sysai85: './sysai85.component.html',
  admi10: './admi10Pkg.component.html',
}

export * from "./services/syska.service";
export * from "./services/sysidname.service";
export * from "./services/sysidnamePkg.service";
export * from "./services/syskaPkg.service";
export * from "./services/syskb.service";
export * from "./services/syskbPkg.service";
export * from "./services/syskc.service";
export * from "./services/syskcPkg.service";
export * from "./services/syskd.service";
export * from "./services/syskdPkg.service";
export * from "./services/sysmsg.service";
export * from "./services/sysmsgPkg.service";
export * from "./services/syssa.service";
export * from "./services/syssaPkg.service";
export * from "./services/syssd.service";
export * from "./services/syssdPkg.service";
export * from "./services/sysse.service";
export * from "./services/syssePkg.service";
export * from "./services/syssf.service";
export * from "./services/syssfPkg.service";
export * from "./services/syssh.service";
export * from "./services/sysshPkg.service";
export * from "./services/sysuser.service";
export * from "./services/sysuserPkg.service";
